export interface AuditActorSummary {
    id?: number | null;
    name?: string | null;
    imageUrl?: string | null;
}

export interface AuditStamp {
    showWhenEmpty?: boolean;
    createdAt?: Date | string | number | null;
    updatedAt?: Date | string | number | null;
    deletedAt?: Date | string | number | null;
    createdAuditSource?: string | null;
    updatedAuditSource?: string | null;
    createdBy?: number | null;
    updatedBy?: number | null;
    deletedBy?: number | null;
    createdByActor?: AuditActorSummary | null;
    updatedByActor?: AuditActorSummary | null;
    deletedByActor?: AuditActorSummary | null;
}

export interface AuditTimelineEvent {
    actor?: AuditActorSummary | null;
    actorId?: number | string | null;
    actorName?: string | null;
    eventType?: string | null;
    fromStatus?: string | null;
    toStatus?: string | null;
    comment?: string | null;
    source?: string | null;
    createdAt?: Date | string | number | null;
}

export function auditActorLabel(actor?: AuditActorSummary | null, actorId?: number | null, source?: string | null): string {
    if (actor?.name === 'System' && actor?.id == null && actorId == null && source !== 'SYSTEM') return 'Not recorded';
    if (actor?.name?.trim()) return actor.name;
    const id = actor?.id ?? actorId;
    if (id != null) return `User #${id}`;
    return source === 'SYSTEM' ? 'System' : 'Not recorded';
}
